
<login-home-navigation></login-home-navigation>
            
<section class="sptb innerpage-margin" style="background-color: #fff;">
    <div class="container">

        <div class="row">
        
            <div class="col-sm-3 col-lg-3 col-md-3">
                <img src="assets/images/media/home/fabbtn.webp" alt="machining" width="100%" height="auto">
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9  blog-detail">	
            <h2>#Fabrication</h2>
								
								
							
								
								<p><b>Fabrication</b> is the process of manufacturing products by cutting, shaping, assembling, and joining raw materials into a final product. It is widely used in industries like construction, automotive, aerospace, and manufacturing. </p>
			</div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6" style="padding-top: 10px;">		
                                <p><b> Types of Fabrication </b></p>
								<p><b>1. Cutting</b></p>
								<p>Cutting involves separating a material into desired shapes using various methods. </p>
								
									<p><li>Shearing: Uses a sharp blade to cut sheets of metal. </li></p>
									<p><li>Laser Cutting: Uses a high-energy laser to cut materials. </li></p>
									<p><li>Plasma Cutting: Uses a high-temperature plasma arc to cut conductive metals. </li></p>
									<p><li>Water Jet Cutting: Uses high-pressure water mixed with abrasives.</li></p>
									
								<p><b>2. Forming</b> </p>
								<p>Forming processes shape materials without removing material.  
								</p>

									<p><li> Bending: Uses press brakes or rollers to bend metal sheets.  </li></p>
									<p><li> Stamping: Uses dies to create raised or indented shapes. </li></p>
									<p><li> Forging: Deforms metal using compressive force.</li></p>
									
                                   <p><b>3. Machining</b> </p>
                                      <p> Machining involves removing material using cutting tools. (<a href="/machining">Machining</a>)  
                                        - Turning, Milling, Drilling, and Grinding.</p>  

                                    <p><b>4. Welding and Joining</b> </p>
                                    <p> Welding and joining methods fuse multiple parts together.  
                                    </p>   
                                    <p><li> Arc Welding (MIG, TIG, Stick Welding): Uses electrical arcs to melt and join metals.    </li></p>
									<p><li> Spot Welding: Uses heat and pressure to fuse metal sheets.  
                                    </li></p>
									<p><li>Brazing & Soldering: Uses filler metals to join materials without melting them.  </li></p>
								
                                    <p><b>5. Assembly </b></p>
                                    <p> Final components are put together using:  
  
                                    </p>   
                                    <p><li> Fastening (Bolts, Rivets, Screws)  </li></p>
									<p><li> Adhesive Bonding (Industrial Glues, Epoxies)    
                                    </li></p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 blog-detail">

									<p><b>Factors Affecting Fabrication Process</b></p>
									<p><li> Material Type: Different metals and plastics require specific techniques.  
                                    </li></p>
									<p><li> Precision & Tolerances: High-precision industries require tight tolerances.  
                                    </li></p>
									<p><li> Cost & Efficiency: Choosing the right fabrication process impacts cost-effectiveness.  
                                    </li></p>
									<p><li> Automation & CNC Technology: Increases accuracy and reduces labor costs.  
                                    </li></p>

									<p><b>Applications of Fabrication</b></p>  
									<p><li>Construction (Steel Structures, Bridges, Buildings) </li></p>  
									<p><li>Automotive & Aerospace (Car Frames, Aircraft Parts) </li></p>  
									<p><li>Manufacturing (Industrial Machinery, Consumer Products)  
                                    </li></p>  
									<p><li>Shipbuilding & Marine Engineering </li></p>  
	

								</div>
								
							</div>
						</div>
                  
</section><!--/Section-->

<section style="background-color:black ;padding-top:5px;">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="container">
            <div class="row">
    
            
            <div class="col-lg-8 col-md-8 col-sm-8 signup">
                <p>Don't fall behind your competitors! If you have the manufacturing setup, join the custom manufacturing community for free.
            </p></div>
            <div class="col-lg-4 col-md-4 col-sm-4">
                <button class="sgnbtn" (click)="signup()">SIGN UP NOW <i class="fa fa-sign-in"></i></button>
            </div>
            
            </div>
        </div>
    </div>
    
</section>


<login-home-footer></login-home-footer>